import { config, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';
import { faSitemap } from '@fortawesome/free-solid-svg-icons/faSitemap';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faChartPie } from '@fortawesome/free-solid-svg-icons/faChartPie';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faRoad } from '@fortawesome/free-solid-svg-icons/faRoad';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faThreads } from '@fortawesome/free-brands-svg-icons/faThreads';

library.add(
  faDatabase,
  faSitemap,
  faKey,
  faChartPie,
  faCheckCircle,
  faRoad,
  faSearch,
  faTimesCircle,
  faInfoCircle,
  faQuestionCircle,
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faYoutube,
  faXTwitter,
  faThreads,
);

config.autoAddCss = false;

const FontAwesomeIconLib = {
  install(app) {
    app.component('font-awesome-icon', FontAwesomeIcon);
  },
};

export default FontAwesomeIconLib;
